@if (tabla.filter ? tabla.filter.length > 0 : false) {
  <c-filter [filtros]="tabla.filter!" (changeInput)="filter($event)" />
}
<div class="flex justify-end">
  @if (tabla.excel) {
    <div class="flex justify-end mt-2">
      <button
        class="py-3 px-5 text-sm font-medium transition-all duration-200 bg-excel-100 hover:bg-excel-200 text-white flex justify-center items-center"
        (click)="generateXlsx()"
      >
        <img src="/svg/xlsx.svg" alt="Icon" width="16" class="mr-1" />
        {{ "Descargar listado (formato XLSX)" }}
      </button>
    </div>
  }
  @if (tabla.pdf) {
    <div class="flex justify-end mt-2 ml-2">
      <button
        class="py-3 px-5 text-sm font-medium transition-all duration-200 bg-primary-500 hover:bg-primary-700 text-white flex justify-center items-center"
        (click)="generatePdf()"
      >
        <img src="/svg/pdf.svg" alt="Icon" width="16" class="mr-1" />
        {{ "Descargar listado (formato PDF)" }}
      </button>
    </div>
  }
</div>
@if (tabla.rowsPerPageOptions ? tabla.rowsPerPageOptions.length > 0 : false) {
  <div class="flex justify-center items-center w-full mt-2">
    <p-paginator
      (onPageChange)="onPageChange($event)"
      [first]="first"
      [rows]="rows"
      class="flex-1"
      [totalRecords]="totalRecords"
      [rowsPerPageOptions]="tabla.rowsPerPageOptions"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{first} - {last} de {totalRecords}"
      dropdownAppendTo="body"
    />
  </div>
}

<p-table
  #table
  [showCurrentPageReport]="true"
  [tableStyle]="{ 'min-width': '10rem' }"
  styleClass="mt-2"
  [value]="data"
  dataKey="id"
  (onSort)="onSort($event)"
>
  <ng-template pTemplate="header">
    <tr class="dark-tr">
      <!-- Preguntamos si marco como casillas seleccionables -->
      @if (tabla.selectable) {
        <th style="width: 20px">
          <div class="flex! justify-center! items-center!">
            <c-checkbox
              #principal
              etiqueta=""
              (click)="otherAction = hasSelectedAll = true"
              (valorChange)="checkAll($event)"
            />
          </div>
        </th>
      }
      @for (item of tabla.table; track $index) {
        @if (item.sortable) {
          <th
            [pSortableColumn]="item.property ? item.property.toString() : ''"
            style="max-width: none"
            #headerCell
            [ngStyle]="item.sticky ? getStickyStyle($index) : null"
          >
            <div class="flex! justify-center! items-center!">
              {{ item.nombre }}
              @if (item.fxName) {
                <button
                  class="ml-2 text-xs text-white bg-primary-500 shadow-md rounded-sm"
                  (click)="item?.fx(data)"
                >
                  {{ returnFxName(item?.fxName, data) }}
                </button>
              }

              <p-sortIcon
                [field]="item.property ? item.property.toString() : ''"
              />
            </div>
          </th>
        } @else {
          <th
            style="text-align: center !important"
            #headerCell
            [ngStyle]="item.sticky ? getStickyStyle($index) : null"
          >
            {{ item.nombre }}
            @if (item.fxName) {
              <button
                class="ml-2 text-xs text-white bg-primary-900 shadow-md rounded-sm p-1"
                (click)="item.fx ? item?.fx(data) : ''"
              >
                {{ returnFxName(item?.fxName, data) }}
              </button>
            }
          </th>
        }
      }
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-i>
    <tr (click)="onRowSelect(i)" class="item">
      <!-- Preguntamos si marco como casillas seleccionables -->
      @if (tabla.selectable) {
        <td style="width: 20px">
          <div class="flex! justify-center! items-center!">
            <c-checkbox
              #check
              etiqueta=""
              (click)="otherAction = selectedOne = true"
              (valorChange)="checkItem(i, $event)"
            />
          </div>
        </td>
      }
      @for (item of tabla.table; track $index) {
        <!-- Si no es un botón, solo pasamos las propiedades -->
        @if (!item.buttons) {
          <!-- Caso que sean fechas -->
          @if (item.isDate) {
            <td
              pTooltip="{{
                returnData(i, item.property, item.subProperty!)
                  ? (returnData(i, item.property, item.subProperty!)
                    | date
                      : (item.hasTime
                          ? (item.formatDate ?? 'dd/MM/yyyy HH:mm')
                          : (item.formatDate ?? 'dd/MM/yyyy')))
                  : 'Sin información'
              }}"
              [style]="{ 'text-align': $index == 0 ? 'start' : 'center' }"
              [class]="item.cssClass"
              tooltipPosition="bottom"
              [ngStyle]="item.sticky ? getStickyStyle($index) : null"
            >
              {{
                returnData(i, item.property, item.subProperty!)
                  ? (returnData(i, item.property, item.subProperty!)
                    | date
                      : (item.hasTime
                          ? (item.formatDate ?? "dd/MM/yyyy HH:mm")
                          : (item.formatDate ?? "dd/MM/yyyy")))
                  : "Sin información"
              }}
            </td>
            <!-- Caso que sean valores booleanos -->
          } @else if (item.isBoolean) {
            <!-- Las clases se aplican dependiendo si le pasaron el cssClass, sino aplica el true o false class -->
            <td
              [pTooltip]="item.booleanValue(i)"
              [style]="{ 'text-align': $index == 0 ? 'start' : 'center' }"
              [class]="item.cssClass ? item.cssClass : item.booleanClass(i)"
              tooltipPosition="bottom"
              [ngStyle]="item.sticky ? getStickyStyle($index) : null"
            >
              {{ item.booleanValue(i) }}
            </td>
            <!-- Caso que sea un array lo que hay que mostrar -->
          } @else if (item.isArray) {
            <td
              [pTooltip]="
                returnDataArray(i, item.property, item.subProperty!)
                  ? returnDataArray(i, item.property, item.subProperty!)
                  : 'Sin información'
              "
              [class]="item.cssClass"
              [style]="{ 'text-align': $index == 0 ? 'start' : 'center' }"
              tooltipPosition="bottom"
              [ngStyle]="item.sticky ? getStickyStyle($index) : null"
            >
              {{
                returnDataArray(i, item.property, item.subProperty!)
                  ? returnDataArray(i, item.property, item.subProperty!)
                  : "Sin información"
              }}
            </td>
          } @else {
            <!-- Caso común -->
            <td
              [pTooltip]="
                returnData(i, item.property, item.subProperty!)
                  ? returnData(i, item.property, item.subProperty!)
                  : 'Sin información'
              "
              [class]="item.cssClass"
              [style]="{ 'text-align': $index == 0 ? 'start' : 'center' }"
              tooltipPosition="bottom"
              [ngStyle]="item.sticky ? getStickyStyle($index) : null"
            >
              {{
                returnData(i, item.property, item.subProperty!) != undefined
                  ? returnData(i, item.property, item.subProperty!)
                  : "Sin información"
              }}
            </td>
          }
          <!-- Caso contrario, creamos el botón -->
        } @else {
          <td
            style="max-width: none"
            [ngStyle]="item.sticky ? getStickyStyle($index) : null"
          >
            <div class="w-full flex justify-center items-center">
              @for (button of item.buttons; track $index) {
                @if (button.shouldRender === "always") {
                  @if (button.type === "radio") {
                    <p-inputSwitch
                      [(ngModel)]="button.checked"
                      (ngModelChange)="otherAction = true; button.fx(i, $event)"
                    />
                  } @else {
                    <div
                      pRipple
                      [classList]="button.class"
                      [pTooltip]="button.text"
                      tooltipPosition="left"
                      [tooltipDisabled]="button.primeIcon ? false : true"
                      (click)="otherAction = true; button.fx(i)"
                    >
                      @if (button.primeIcon) {
                        <i class="pi {{ button.primeIcon }}"></i>
                      } @else {
                        <p>{{ button.text }}</p>
                      }
                    </div>
                  }
                } @else if (button.conditionValue(i)) {
                  @if (button.type === "radio") {
                    <p-toggleswitch
                      [ngModel]="button?.checked(i) || false"
                      (onChange)="
                        otherAction = true; button.fx(i, $event.checked)
                      "
                    />
                  } @else {
                    <div
                      pRipple
                      [classList]="button.class"
                      [pTooltip]="button.text"
                      tooltipPosition="left"
                      [tooltipDisabled]="button.primeIcon ? false : true"
                      (click)="otherAction = true; button.fx(i)"
                    >
                      @if (button.primeIcon) {
                        <i class="pi {{ button.primeIcon }}"></i>
                      } @else {
                        <p>{{ button.text }}</p>
                      }
                    </div>
                  }
                }
              }
            </div>
          </td>
        }
      }
    </tr>
  </ng-template>
</p-table>

@if (tabla.rowsPerPageOptions ? tabla.rowsPerPageOptions.length > 0 : false) {
  <div class="flex justify-center items-center w-full mt-2">
    <p-paginator
      (onPageChange)="onPageChange($event)"
      [first]="first"
      [rows]="rows"
      class="flex-1"
      [totalRecords]="totalRecords"
      [rowsPerPageOptions]="tabla.rowsPerPageOptions"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{first} - {last} de {totalRecords}"
      dropdownAppendTo="body"
    />
  </div>
}
